/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import styled from 'styled-components'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Badge, Card, Theme } from '@nexigendigital/nxui'
import { Weight } from 'models/enums'
import { useAppSelector } from 'store/hooks'

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function BillingDetails() {
    const { appSession: { user, account } } = useAppSelector((state) => state.app)
    const { firstname, lastname } = user!
    const { paymentMethod } = useAppSelector((state) => state.shop)

    /****************************************************
     *  FUNCTIONS
     ****************************************************/
    function Billing() {
        if (!paymentMethod) {
            return null
        }

        return (
            <>
                <Account>
                    <div>Account</div>
                    <Information>
                        <span>{`${firstname} ${lastname}`}</span>
                        <Badge color={'primary'}>{account!.account_number}</Badge>
                    </Information>
                </Account>
                <Payment>
                    <div>Payment Method</div>
                    <div>{paymentMethod.identifier}</div>
                </Payment>
            </>
        )
    }

    if (!paymentMethod) {
        return null
    }

    return (
        <StyledBillingDetails>
            <Card title={'Billing Details'}>
                <Billing/>
            </Card>
        </StyledBillingDetails>
    )
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const StyledBillingDetails = styled.div`
    article {
        > div {
            padding: 0;
            display: flex;
            flex-direction: column;
        }
    }
`

const Account = styled.div`
    padding: 18px 24px;
    display: flex;
    justify-content: space-between;
    ${Theme.Functions.setFont('Inter', Weight.Medium)};

    > div:first-child {
        color: ${props => props.theme['text--100']}
    }
`

const Payment = styled.div`
    padding: 18px 24px;
    display: flex;
    justify-content: space-between;
    border-top: 1px solid ${props => props.theme['gray--100']};

    > div:first-child {
        color: ${props => props.theme['text--100']}
    }

    > div:nth-child(2) {
        ${Theme.Functions.setFont('Inter', Weight.Medium)};
        color: ${props => props.theme['text--300']}
    }
`

const Information = styled.div`
    display: flex;
    align-items: center;
    gap: 10px;

    > span {
        ${Theme.Functions.setFont('Inter', Weight.Medium)};
        color: ${props => props.theme['text--300']};
    }
`
